import { css } from 'lit';
import { errorClassName } from '../../shared/styles/form-control.styles.js';
export const toggleStyles = css `
    .hlx-form-control {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .hlx-toggle {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }

    .hlx-toggle-container {
        display: inline-flex;
        gap: var(--hlx-spacing-md);
        cursor: pointer;
    }

    .hlx-toggle:focus-visible + .hlx-toggle-container .hlx-toggle-control {
        outline: 2px solid var(--hlx-color-brand-default);
        outline-offset: 1px;
    }

    .hlx-toggle-container:not(:is(.hlx-toggle-disabled, .hlx-toggle-readonly)):hover
        .hlx-toggle-control {
        background-color: var(--hlx-toggle-input-background-color-off-hover);
    }

    .hlx-toggle-disabled,
    .hlx-toggle-readonly {
        cursor: not-allowed;
    }

    .hlx-toggle-disabled .hlx-toggle-label {
        color: var(--hlx-input-label-color-disabled);
    }

    .hlx-toggle-disabled .hlx-toggle-description {
        color: var(--hlx-input-text-color-disabled);
    }

    .hlx-toggle-checked:not(:is(.hlx-toggle-disabled, .hlx-toggle-readonly)) .hlx-toggle-control {
        background-color: var(--hlx-toggle-input-background-color-on-default);
    }

    .hlx-toggle-checked:not(:is(.hlx-toggle-disabled, .hlx-toggle-readonly)):hover
        .hlx-toggle-control {
        background-color: var(--hlx-toggle-input-background-color-on-hover);
    }

    .hlx-toggle-checked .hlx-toggle-icon-wrapper {
        transform: translateX(100%);
    }

    .hlx-toggle-icon-wrapper {
        display: inline-flex;
        transition: transform var(--hlx-motion-duration-default) var(--hlx-motion-easing-in-out);
        margin: var(--hlx-spacing-2xs);
    }

    .hlx-toggle-icon {
        color: var(--hlx-toggle-input-color-inverted);
    }

    .hlx-toggle-secondary-container {
        display: flex;
        flex-direction: column;
        gap: var(--hlx-spacing-2xs);
    }

    .hlx-toggle-control {
        display: flex;
        width: 40px;
        height: 24px;
        flex-shrink: 0;
        border-radius: var(--hlx-radius-full);
        background-color: var(--hlx-toggle-input-background-color-off-default);
        transition: background-color var(--hlx-motion-duration-default)
            var(--hlx-motion-easing-in-out);
    }

    .hlx-toggle-indeterminate .hlx-toggle-control {
        justify-content: center;
    }

    .hlx-toggle-label {
        display: none;
        color: var(--hlx-input-label-color-default);
        font-size: var(--hlx-text-font-size-md);
        font-weight: var(--hlx-text-font-weight-medium);
        line-height: var(--hlx-text-line-height-tight-1);
    }

    .hlx-toggle-description {
        display: none;
        color: var(--hlx-input-help-text-color);
        font-size: var(--hlx-text-font-size-md);
        font-weight: var(--hlx-text-font-weight-normal);
        line-height: var(--hlx-text-line-height-tight-1);
    }

    .hlx-toggle-content {
        margin-left: calc(var(--hlx-spacing-md) + 40px);
    }

    .hlx-default-slot {
        margin-top: var(--hlx-spacing-xs);
    }

    .${errorClassName} .hlx-toggle-control {
        outline: 2px solid var(--hlx-input-border-color-error);
        outline-offset: 1px;
    }

    .hlx-toggle-has-default-slot .hlx-default-slot {
        display: block;
    }

    .hlx-toggle-has-label .hlx-toggle-label {
        display: block;
    }

    .hlx-toggle-has-description .hlx-toggle-description {
        display: block;
    }

    .hlx-toggle-error {
        margin-top: var(--hlx-spacing-2xs) !important;
    }
`;
//# sourceMappingURL=toggle.styles.js.map